import { ref, computed } from "vue";
import { useStore } from "@nuxtjs/composition-api";
import { useUser } from "/composables/useUser";
import axios from "axios";
import { find } from "lodash";

const state = ref({
  lists: [],
  by_market: [],
});

function compare(a, b) {
  // if (new Date(a.update_date_unix) - new Date(b.update_date_unix)) {
  //   return -1;
  // }
  if (new Date(a.update_date_unix) + new Date(b.update_date_unix)) {
    return 1;
  }
  // a must be equal to b
  return 0;
}

export const useLists = () => {
  const store = useStore();
  const { logged } = useUser();

  const CancelToken = axios.CancelToken;
  let source;

  async function callApi(url, cancelTokenSource) {
    // cancel the request
    if (source) {
      source.cancel("Operation canceled by the user.");
      source = null;
    }

    source = cancelTokenSource;

    const { data } = await axios.get(
      encodeURI(url),
      cancelTokenSource
        ? {
            cancelToken: source.token,
          }
        : null
    );

    if (data.items) {
      for (let i = 0; i < data.items.length; i++) {
        const unixDate = data.items[i].date_unix * 1000;
        if (store.state.market != "it") {
          data.items[i].display_date = new Date(unixDate).toDateString();
        } else {
          data.items[i].display_date = new Date(unixDate).toLocaleString(
            "it-IT",
            {
              month: "2-digit",
              day: "2-digit",
              year: "numeric",
            }
          );
        }
      }

      data.items.sort(compare);

      state.value.lists = data.items;
    }

    if (data.by_market) {
      state.value.by_market = data.by_market;
    }

    return data;
  }

  async function addList(listName, recaptcha) {
    return await callApi(
      `${store.state.wsPath}get_lists?action=add-list&user=${store.state.user.id}&recaptcha=${recaptcha}&token=${store.state.user.token}&name=${listName}&lang=${store.state.lang}&market=${store.state.market}`
    );
  }

  async function getList() {
    return await callApi(
      `${store.state.wsPath}get_lists?action=get-list&all&user=${store.state.user.id}&token=${store.state.user.token}&lang=${store.state.lang}&market=${store.state.market}`
    );
  }

  async function removeList(listId, recaptcha) {
    return await callApi(
      `${store.state.wsPath}get_lists?action=remove-list&list_id=${listId}&user=${store.state.user.id}&recaptcha=${recaptcha}&token=${store.state.user.token}&lang=${store.state.lang}&market=${store.state.market}`
    );
  }

  async function editList(listId, listName, recaptcha) {
    return await callApi(
      `${store.state.wsPath}get_lists?action=update-list-title&name=${listName}&recaptcha=${recaptcha}&list_id=${listId}&user=${store.state.user.id}&token=${store.state.user.token}&lang=${store.state.lang}&market=${store.state.market}`
    );
  }

  async function duplicateList(listId, listName, recaptcha) {
    return await callApi(
      `${store.state.wsPath}get_lists?action=duplicate-list&list_id=${listId}&recaptcha=${recaptcha}&name=${listName}&user=${store.state.user.id}&token=${store.state.user.token}&lang=${store.state.lang}&market=${store.state.market}`
    );
  }

  async function addItem(listId, sku, recaptcha, qty = 1) {
    return await callApi(
      `${store.state.wsPath}get_lists?action=add-product&list_id=${listId}&qty=${qty}&recaptcha=${recaptcha}&product=${sku}&user=${store.state.user.id}&token=${store.state.user.token}&lang=${store.state.lang}&market=${store.state.market}`
    );
  }

  async function removeItem(listId, sku, recaptcha) {
    return await callApi(
      `${store.state.wsPath}get_lists?action=remove-product&list_id=${listId}&recaptcha=${recaptcha}&product=${sku}&user=${store.state.user.id}&token=${store.state.user.token}&lang=${store.state.lang}&market=${store.state.market}`
    );
  }

  async function updateListPrivacy(listId, isPrivate, recaptcha) {
    return await callApi(
      `${store.state.wsPath}get_lists?action=update-list-privacy&user=${store.state.user.id}&recaptcha=${recaptcha}&privacy=${isPrivate}&list_id=${listId}&token=${store.state.user.token}&lang=${store.state.lang}&market=${store.state.market}`
    );
  }

  async function updateSkuQuantity(listId, qty, sku) {
    return await callApi(
      `${store.state.wsPath}get_lists?&action=change-qty&list_id=${listId}&qty=${qty}&sku=${sku}&user=${store.state.user.id}&token=${store.state.user.token}&lang=${store.state.lang}&market=${store.state.market}`,
      CancelToken.source()
    );
  }

  function isPrivateById(listId) {
    return (
      find(state.value.lists, function (o) {
        return o.is_private == true && o.id == listId;
      }) != undefined
    );
  }

  function isOwnerById(listId) {
    if (!logged.value) {
      return false;
    }
    return (
      find(state.value.lists, function (o) {
        return o.is_owner == true && o.id == listId;
      }) != undefined
    );
  }

  return {
    lists: computed(() => state.value.lists),
    byMarket: computed(() => state.value.by_market),
    addList,
    getList,
    removeList,
    editList,
    duplicateList,
    addItem,
    removeItem,
    isPrivateById,
    isOwnerById,
    updateListPrivacy,
    updateSkuQuantity,
  };
};
